import { Platform } from 'react-native';

export const isWeb = Platform.OS === 'web';
export const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';

export const isEmulator = () => {
  if (Platform.OS === 'ios') {
    return Platform.constants.simulator;
  }
  
  if (Platform.OS === 'android') {
    return !Platform.constants.Brand || Platform.constants.Brand === 'generic';
  }
  
  return false;
};

export const getDeviceType = () => {
  if (isWeb) return 'web';
  if (isEmulator()) return `${Platform.OS}-emulator`;
  return Platform.OS;
};

// For development debugging
if (__DEV__) {
  console.log('Platform Info:', {
    platform: Platform.OS,
    isWeb,
    isMobile,
    isEmulator: isEmulator(),
    deviceType: getDeviceType()
  });
}
